import { Skeleton } from "@cynthai/ui";

type Props = {
  count?: number;
  className?: string;
};

export default function SearchResultsSkeleton({
  count = 6,
  className = "",
}: Readonly<Props>) {
  const step = 2250 / count;

  return (
    <div className={`w-full ${className} `} aria-hidden="true">
      <div className={`grid grid-cols-2 gap-4 py-10 2xl:grid-cols-3`}>
        <Skeleton.List count={count} className="contents">
          {(i) => (
            <div
              key={i}
              className="pointer-events-none"
              style={{ animationDelay: `${i * step}ms` }}
            >
              <div
                className={`border-tertiary/40 bg-tertiary/80 dark:border-tertiary/20 dark:bg-tertiary/25 h-85 rounded-md border p-6`}
              >
                <Skeleton
                  className={`dark:bg-background h-40 w-full bg-slate-900/15`}
                  stagger={i}
                />
                <Skeleton.Text
                  size="md"
                  className={`dark:bg-tertiary/30 mt-6 ml-2 bg-slate-400/15`}
                  stagger={i}
                />
                <Skeleton.Text
                  size="md"
                  className={`dark:bg-tertiary/30 mt-2 ml-2 bg-slate-400/15`}
                  stagger={i}
                />
                <Skeleton.Text
                  size="lg"
                  className={`dark:bg-tertiary/30 mt-2 ml-2 bg-slate-400/15`}
                  stagger={i}
                />
                <Skeleton.Text
                  size="md"
                  width="1/3"
                  className={`dark:bg-tertiary/30 mt-2 ml-2 bg-slate-400/15`}
                  stagger={i}
                />
              </div>
            </div>
          )}
        </Skeleton.List>
      </div>
    </div>
  );
}
